module.exports = __webpack_public_path__ + "img/tree-07-e-leaves.6c77840d.png";